import { get, isArray } from 'lodash-es';

/**
 * Takes an array and makes a lookup object where the keys are the values of the array
 * and the values are 1. Useful if you don't want to use a Set which doesn't allow
 * lookups with `mySet[key]`
 * @param {Array} array
 */
const arrayToLookupObject = array => isArray(array)
  && array.reduce((memo, v) => {
    memo[v] = 1;
    return memo;
  }, {});

export const UPDATE_USER = 'USER/UPDATE_USER';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
};

export const updateUser = data => dispatch => {
  dispatch({
    type: UPDATE_USER,
    data
  });
};

export const updateUserTransformer = (data, isSuperUser, houseConfig) => {
  let interpretUserData = {
    accessInvoices: false,
    accessReports: false,
    accessCalendar: true,
    accessCustomer: false,
    accessSensitive: false,
    accessMessages: true,
    accessConsole: true,
    // accessAssoc: false,
    accessInventory: false,
    accessSettlement: false,
    accessUsers: false,
    associationManager: false,
    diyAllowed: false,
    isInstant: false,
    isSuperUser: false,
    paymentProcessingAccountID: null,
    paymentProcessingEligible: false,
    userLevelA: true,
    userLevelB: false,
    userLevelC: false
  };

  /**
   * (dyouberg) I'm not sure what superUser is when coming from /app/house/user but the
   * isSuperUser should be based on the /app/house/HOUSEREF/user/USERREF call.
   *
   * Keeping the other superUser logic in here for now but sending back the boolean value
   * in the first line of interpretUserData so that the proper superUser only links are
   * hidden from non super users
   */
  const superUser = get(data, 'superUser');

  if (superUser || get(data, 'user')) {
    const user = superUser || get(data, 'user');
    const houseInfo = get(data, 'user.houseInfo');
    const access = arrayToLookupObject(get(user, 'accessTypes', []));
    const { bulkBiddingEnabled = false } = houseConfig || {};

    interpretUserData = {
      isSuperUser,
      diyAllowed: !(get(houseInfo, 'isManual') || get(houseInfo, 'isRFCLiveFeed')),
      isInstant: get(houseInfo, 'isInstant'),
      connectType: get(houseInfo, 'connectType'),
      paymentProcessingAccountID: get(houseInfo, 'paymentProcessingAccountID'),
      paymentProcessingEligible: get(houseInfo, 'paymentProcessingEligible'),
      paymentProcessingEnabled: get(houseInfo, 'paymentProcessingEnabled'),
      associationManager: user.associationManager,
      userLevelC: houseInfo.houseType === 'premium',
      userLevelB: houseInfo.houseType === 'live',
      userLevelA: houseInfo.houseType === 'basic',

      // User Administrator
      accessUsers: access.a,
      // Auction Calendar
      accessCalendar: access.d,
      // Live Auction Console
      accessConsole: access.l,
      // Bidder Details & Approval
      accessCustomer: access.b,
      // Invoices
      accessInvoices: access.i,
      // Message Center
      accessMessages: access.m,
      // Payment Processing
      accessPayments: access.i && access.y,
      // Reports
      accessReports: access.r,
      // Sensitive Data
      accessSensitive: access.s,
      // Bulk Bidding
      accessBulkbiding: bulkBiddingEnabled && (access.z || !!isSuperUser),

      // Currently unused?
      accessInventory: access.v,
      accessSettlement: access.y
      /**
       * As per Mike K. - Assoc probably refers to Association management,
       * which was something we were going to have for AZG, but which
       * obviously was never put into place.
       */
      // accessAssoc: access['g'],
    };
  }
  const transformed = { ...data.user, ...data.superUser, ...interpretUserData };
  delete transformed.houseInfo;
  return transformed;
};
